import React, { useEffect, useState } from "react";
import { useAuth } from "../../Context/AuthContext";
import { useToast } from "../../Context/ToastContext";
import toast, { Toaster } from "react-hot-toast";
import { API_URL, useAxios } from "../../utils/const";

const Navbar = ({ toggled, setToggled }) => {
  const axiosInstance = useAxios();
  const { toastObj, setToastObj } = useToast();
  const { logout } = useAuth();
  const [username, setUsername] = useState("");

  useEffect(() => {
    getUserById();
  }, []);

  useEffect(() => {
    if (toastObj.type === "success") {
      toast.success(toastObj.msg);
      setToastObj({ msg: null, type: null });
    } else if (toastObj.type === "danger") {
      toast.error(toastObj.msg);
      setToastObj({ msg: null, type: null });
    }
  }, [toastObj]);

  const getUserById = async () => {
    const response = await axiosInstance.get(`${API_URL}/users/find-by/token`);
    setUsername(response.data.data.name);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <nav
      className={`navbar fixed-top sb-topnav px-4 ${toggled ? "toggled" : ""}`}
    >
      <Toaster position="top-right" />
      <div className="">
        <i
          onClick={() => setToggled(!toggled)}
          className="fas fa-bars"
          style={{ cursor: "pointer" }}
        ></i>
      </div>
      <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
        <li className="nav-item dropdown">
          <a
            className="nav-link nav-link-ams"
            style={{ color: "rgba(255, 255, 255, 0.55)" }}
            id="navbarDropdown"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {username ?? "-"} <i className="fas fa-user fa-fw"></i>
          </a>
          <ul
            className="dropdown-menu dropdown-menu-end"
            aria-labelledby="navbarDropdown"
          >
            <li>
              <a
                className="dropdown-item"
                style={{ cursor: "pointer" }}
                onClick={handleLogout}
              >
                Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
